var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTaxi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#212121;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "taxi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49769",
    "data-name": "Group 49769"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28715",
    "data-name": "Path 28715",
    className: "cls-1",
    d: "M31.45,14.67,17.33.55a1.89,1.89,0,0,0-2.66,0L.55,14.67a1.88,1.88,0,0,0,0,2.65L14.67,31.45a1.89,1.89,0,0,0,2.66,0L31.45,17.33a1.89,1.89,0,0,0,0-2.66Zm-.88,1.77L16.44,30.57a.63.63,0,0,1-.88,0L1.43,16.44a.63.63,0,0,1,0-.88L15.56,1.43a.63.63,0,0,1,.88,0L30.57,15.56a.63.63,0,0,1,0,.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28716",
    "data-name": "Path 28716",
    className: "cls-1",
    d: "M16.44,3.2a.61.61,0,0,0-.88,0L3.2,15.56a.63.63,0,0,0,0,.88L13.69,26.91a.63.63,0,0,0,.92-.86l0,0L4.52,16,16,4.52,27.48,16,16,27.47l-1.82-1.81a.62.62,0,0,0-.88,0,.61.61,0,0,0,0,.85l2.26,2.26a.63.63,0,0,0,.88,0L28.8,16.44a.63.63,0,0,0,0-.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28717",
    "data-name": "Path 28717",
    className: "cls-1",
    d: "M16.11,18.5a.63.63,0,0,0,.63-.62h0v-2.5A1.88,1.88,0,1,0,13,15.29v2.59a.63.63,0,0,0,1.25,0v-.63h1.25v.63A.62.62,0,0,0,16.11,18.5ZM14.24,16v-.62a.63.63,0,1,1,1.25,0V16Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28718",
    "data-name": "Path 28718",
    className: "cls-1",
    d: "M17.77,18.39a.64.64,0,0,0,.87-.17h0l.73-1.1.73,1.1a.63.63,0,0,0,1-.7l-1-1.53,1-1.53a.63.63,0,1,0-1-.7l-.73,1.1-.73-1.1a.64.64,0,0,0-.87-.17.63.63,0,0,0-.17.87l1,1.53-1,1.53a.62.62,0,0,0,.17.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28719",
    "data-name": "Path 28719",
    className: "cls-1",
    d: "M23.25,17.87V14.12a.63.63,0,0,0-1.25,0v3.75a.63.63,0,1,0,1.25,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28720",
    "data-name": "Path 28720",
    className: "cls-1",
    d: "M11.88,13.5H9.38a.63.63,0,1,0,0,1.25H10v3.12a.63.63,0,1,0,1.25,0h0V14.75h.63a.63.63,0,0,0,0-1.25Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaxi);
export default __webpack_public_path__ + "static/media/taxi.fc8250ad59e0c8ff6f958161be1e6910.svg";
export { ForwardRef as ReactComponent };